<template>
    <div class="main">
        <router-view></router-view>
    </div>
</template>
<style scoped>
    .main {
        width: 100%;
        height: 100%;
    }
</style>
<script>
    export default {
        name: 'App',
        components: {
        },
        props: {},
        data() {
            return {
            }
        },
        computed: {
        },
        watch: {
        },
        methods: {
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
        }
    }
</script>


// WEBPACK FOOTER //
// src/App.vue